function formatTime(value) {  // 转日期一定要记得 月份 + 1
    if (!value) {
        return ''
    }
    if (value) {
        let date = new Date(Number(value)),
            year = date.getFullYear(),
            month = date.getMonth(),
            day = date.getDate(),
            newMonth = `${month + 1}`.padStart(2, '0'),
            newDay = `${day}`.padStart(2, '0'),
            hour = date.getHours(),
            newHour = `${hour}`.padStart(2, '0'),
            minute = date.getMinutes(),
            newMinute = `${minute}`.padStart(2, '0');

        return `${year}-${newMonth}-${newDay} ${newHour}:${newMinute}`;
    } else {
        return ''
    }

}


export default formatTime;


// WEBPACK FOOTER //
// ./src/mixins/filters/formatTime.js